module.exports = __webpack_public_path__ + "img/quiz_button.f8874724.jpg";